import { ActionMenu } from "@telluscompany/design-system";
import { Edit, MoreVerticalIcon, Trash2 } from "lucide-react";

import { useLocalization } from "@i18n";

import type { AdminStructureRaisingHistoryListItem } from "../../api/structures/structures.types";

export type AdminStructureRaisingHistoryActionMenuProps = {
  row: AdminStructureRaisingHistoryListItem;
  onEdit: (row: AdminStructureRaisingHistoryListItem) => void;
  onDelete: (row: AdminStructureRaisingHistoryListItem) => void;
};

export const AdminStructureRaisingHistoryActionMenu = ({
  row,
  onEdit,
  onDelete,
}: AdminStructureRaisingHistoryActionMenuProps) => {
  const { translate } = useLocalization();

  return (
    <ActionMenu
      menu={[
        {
          actions: [
            {
              label: translate("admin.structures.raisingHistory.button.edit"),
              onClick: () => onEdit(row),
              icon: <Edit size={16} />,
            },
            {
              label: translate("admin.structures.raisingHistory.button.delete"),
              onClick: () => onDelete(row),
              icon: <Trash2 size={16} />,
              colorTitle: "red" as const,
            },
          ],
        },
      ]}
      trigger={
        <MoreVerticalIcon data-testid="raising-history-action-menu-trigger" />
      }
    />
  );
};
